import classNames from 'classnames';
import type { ReactElement, Ref, RefObject } from 'react';
import { useRef } from 'react';
import styles from './NoFilterResultMessage.module.scss';
import { setupTransitionInTimeline } from './NoFilterResultMessage.transitions';
import type {
  NoFilterResultMessageProps,
  NoFilterResultMessageRef,
} from './NoFilterResultMessage.data';
import { useScrollTransition } from 'util/react-transition-component';
import Text from '../text/Text';
import PrimaryButton from '../primary-button/PrimaryButton';
import type { PrimaryButtonRef } from '../primary-button/PrimaryButton.data';

export default function NoFilterResultMessage({
  onResetClick,
  message,
  cta,
  ref,
  ...props
}: NoFilterResultMessageProps & { ref?: Ref<NoFilterResultMessageRef> }): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;
  const linkRef = useRef<PrimaryButtonRef>(null);

  useScrollTransition({
    scroll: {
      trigger: elementRef,
      vars: {},
    },
    setupOptions: () => ({
      refs: {
        elementRef,
      },
      setupTransitionInTimeline,
    }),
  });

  return (
    <div
      ref={elementRef}
      className={classNames(
        styles.noFilterResultMessage,
        props.className,
        'grid-gutter',
        'max-content-width',
      )}
    >
      <Text
        as="span"
        size="quote-small"
        className={classNames(styles.description)}
        disableTriggerInOnScroll={false}
      >
        {message}
      </Text>

      <PrimaryButton
        ref={linkRef}
        className={classNames(styles.button)}
        label={cta}
        disableTriggerInOnScroll={false}
        onClick={onResetClick}
      />
    </div>
  );
}
